import React from 'react';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';
import Sheet from '@mui/joy/Sheet';
import { toast } from 'react-toastify';
import Modal from '@mui/joy/Modal';
import { useTextEditorDrawer } from '@/contexts/TextEditorDrawerContext';

const PostNowModal = ({ setOpenDrawer, PostId, isPostNowModalOpen, setIsPostNowModalOpen }) => {
    const { openManagePost, setOpenManagePost, toggleDrawer } = useTextEditorDrawer();

    const handlePostNow = async () => {
        try {
            setIsPostNowModalOpen(false);
            const response = await fetch(`/api/schedule/create`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    post_id: PostId,
                    status: 'Immediate',
                }),
            });

            const data = await response.json();

            if (response.status === 200) {
                setOpenManagePost(false);
                toast.success('This post has been scheduled!');
            }

            else {
                const error_message = data.error || 'An error occurred while scheduling the post.';
                toast.error(error_message);
            }

            if (data.message) {
                setOpenManagePost(false);
            }
        } catch (error) {
            console.error("Error updating post:", error);
        }
    }

    return (
        <Modal open={isPostNowModalOpen} onClose={() => setIsPostNowModalOpen(false)} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999999 }}>
            <Sheet
                variant="outlined"
                sx={{
                    maxWidth: 500,
                    borderRadius: 'md',
                    p: 3,
                    boxShadow: 'lg',
                    backgroundColor: 'white',
                }}
            >
                <Box sx={{ padding: '1rem' }}>
                    <Typography level="h4" variant="plain">Are you sure you want to post right now?</Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '1rem' }}>
                        <Button
                            sx={{ flex: 1, marginRight: '0.5rem' }}
                            size="lg"
                            color="primary"
                            onClick={handlePostNow}
                        >
                            Post Now
                        </Button>
                        <Button
                            sx={{ flex: 1, marginLeft: '0.5rem' }}
                            size="lg"
                            color="danger"
                            variant="outlined"
                            onClick={() => setIsPostNowModalOpen(false)}
                        >
                            Cancel
                        </Button>
                    </Box>
                </Box>
            </Sheet>
        </Modal>
    );
};

export default PostNowModal;
